// extracted by mini-css-extract-plugin
export default {"form":"amfiProducts_form__Ek7tE","labelCol":"amfiProducts_labelCol__OD8fH"};